import React from 'react';
import { RadioGroup as CatalystRadioGroup, Radio, RadioField } from '../Catalyst/radio';
import { Label } from '../Catalyst/fieldset';
import { isEmpty } from '../../common/utils';
import { ClipLoader } from 'react-spinners';

const RadioGroup = ({
    name,
    value,
    children,
    onChange,
    error,
    loading = false,
}) => {

    const handleChange = (newValue) => onChange(null, {
        name,
        value: newValue
    })

    return (
        <div className="relative">
            <CatalystRadioGroup name={name} value={value} onChange={handleChange}>
                {children?.map((child) => (
                    <div className={'flex flex-col justify-between w-full my-2'} key={child.key}>
                        <RadioField>
                            <Radio value={child.value} />
                            <Label className="flex items-center gap-2">
                                {child.text}
                                {child.icon && <img className='h-5' src={child.icon} alt="" />}
                            </Label>
                        </RadioField>
                        <div className="pl-7">
                            {(value === child.value && !isEmpty(child.children)) && child.children}
                        </div>
                    </div>
                ))}
                {error && <p className="text-sm mt-1 text-text-error">{error}</p>}
            </CatalystRadioGroup>
            {loading && (
                <div className="absolute right-3 top-1/2 -translate-y-[45%] z-50 pointer-events-none bg-surface">
                    <ClipLoader color="#6366f1" size={18} />
                </div>
            )}
        </div>
    );
}

export default RadioGroup;